import documents from './documents'

export default { documents }
